import ServiceBase from '@ekd/portal-connector/dist/Service';

import { createCheckAccessService } from './checkAccess.service';
import { createCheckAdFreeService } from './checkAdFree.service';
import { createGetSubscriptionService } from './getSubscription.service';

import { ApiUrls } from '@root/common/types/apiUrls';

export function createPaywallService({ service }: { service: ServiceBase<ApiUrls> }) {
  const { checkAccess } = createCheckAccessService({ service });
  const { checkAdFree } = createCheckAdFreeService({ service });
  const { getSubscription } = createGetSubscriptionService({ service });

  return {
    checkAccess,
    checkAdFree,
    getSubscription,
  };
}
